export var actionKey = '@@nft';
//# sourceMappingURL=constants.js.map